import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

// Shown to an account owner whose renewal payment was declined. Updating the
// card settles the failed invoice on the SAME subscription; buying the plan
// again (what customers did before this existed) left the old subscription
// past due and counted them as churned.
//
// mem_payment_failed comes from site-settings and is only set for the owner
// whose latest subscription is blocked for a failed payment.
//
//   <PaymentFailedBanner />                         // links to Billing
//   <PaymentFailedBanner onUpdateCard={open} />     // opens the card form here
const PaymentFailedBanner = ({ onUpdateCard }) => {
  const failed = useSelector(
    (state) => state?.fetchSiteSettings?.site_settings?.member?.mem_payment_failed
  );

  if (!failed) return null;

  const plan = failed.plan_name ? `${failed.plan_name} ` : "";

  return (
    <div
      role="alert"
      data-testid="payment-failed-banner"
      style={{
        background: "#fdecea",
        border: "1px solid #e57373",
        color: "#611a15",
        padding: "12px 16px",
        borderRadius: 4,
        margin: "12px 0",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
        flexWrap: "wrap",
      }}
    >
      <span style={{ fontSize: 14 }}>
        We couldn't process the latest payment for your {plan}subscription.
        Update your card to keep it — there's no need to subscribe again.
      </span>
      {onUpdateCard ? (
        <button type="button" className="site_btn sm_btn" onClick={onUpdateCard}>
          Update Card
        </button>
      ) : (
        <Link
          to="/account-settings"
          className="site_btn sm_btn"
          onClick={() => {
            try {
              localStorage.setItem("accout-settings-active-tab", "Billing");
            } catch (_) {
              // localStorage may be blocked; the settings page still opens.
            }
          }}
        >
          Update Card
        </Link>
      )}
    </div>
  );
};

export default PaymentFailedBanner;
